import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { auth, db } from './firebase';
import Login from './Login';
import Register from './Register';
import Dashboard from './Dashboard';
import Feed from './Feed';
import Contato from './Contato';
import ProtectedRoute from './ProtectedRoute';
import Logout from './Logout';
import Upload from './Upload';
import Home from './Home';
import VideoPlayer from './VideoPlayer';
import Success from './Success';
import AdminUsers from './AdminUsers';
import AdminSupport from './AdminSupport';

const App = () => {
  const [user, setUser] = useState(null);
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
      if (firebaseUser) {
        setUser(firebaseUser);
        try {
          // Busca dados de pagamento e perfil com segurança
          const userSnap = await getDoc(doc(db, 'users', firebaseUser.uid));
          if (userSnap.exists()) {
            setUserData(userSnap.data());
          } else {
            // Fallback para novos usuários
            setUserData({ isPaid: firebaseUser.email === process.env.REACT_APP_ADMIN_EMAIL });
          }
        } catch (err) {
          console.error("Erro de segurança ao buscar dados:", err);
        }
      } else {
        setUser(null);
        setUserData(null);
      }
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-[#020617] flex items-center justify-center">
        <div className="w-12 h-12 border-4 border-emerald-500 border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  return (
    <Router>
      <Routes>
        <Route path="/" element={user ? <Navigate to="/dashboard/feed" /> : <Home />} />
        <Route path="/login" element={user ? <Navigate to="/dashboard/feed" /> : <Login />} />
        <Route path="/register" element={user ? <Navigate to="/dashboard/feed" /> : <Register />} />

        {/* Rotas Protegidas (Membro Comum) */}
        <Route element={<ProtectedRoute user={user} />}>
          <Route path="/dashboard" element={<Dashboard userData={userData} />}>
            <Route index element={<Navigate to="/dashboard/feed" replace />} />
            <Route path="feed" element={<Feed userData={userData} />} />
            <Route path="video/:id" element={<VideoPlayer userData={userData} />} />
            <Route path="contato" element={<Contato />} />
            <Route path="sucesso" element={<Success />} />
            <Route path="logout" element={<Logout />} />

            {/* Sub-rotas Protegidas (Somente Admin @admin.com) */}
            <Route element={<ProtectedRoute user={user} isAdminRequired={true} />}>
              <Route path="upload" element={<Upload />} />
              <Route path="usuarios" element={<AdminUsers />} />
              <Route path="suporte" element={<AdminSupport />} />
            </Route>
          </Route>
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
};

export default App;
